import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = {
  key: 0,
  class: "card card-body text-muted text-center py-4"
}
const _hoisted_4 = { class: "card card-body mb-0" }
const _hoisted_5 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "row m-4 mt-0"
}
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "card card-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "form-label text-capitalize-first" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "form-check form-check-inline" }
const _hoisted_16 = {
  class: "form-check-label",
  for: "audienceModeSaved"
}
const _hoisted_17 = { class: "form-check form-check-inline" }
const _hoisted_18 = {
  class: "form-check-label",
  for: "audienceModeAdhoc"
}
const _hoisted_19 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_20 = { class: "form-label text-capitalize-first" }
const _hoisted_21 = { value: null }
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_24 = { class: "d-flex flex-wrap align-items-center gap-3" }
const _hoisted_25 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_26 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 1,
  class: "row m-4 mt-0"
}
const _hoisted_29 = { class: "col-sm-12" }
const _hoisted_30 = { class: "card card-body" }
const _hoisted_31 = { class: "text-end mb-2" }
const _hoisted_32 = { class: "overflow-auto" }
const _hoisted_33 = { class: "table table-striped border-light align-middle text-nowrap" }
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  class: "row m-4 mt-0"
}
const _hoisted_38 = { class: "col-sm-12" }
const _hoisted_39 = { class: "card card-body" }
const _hoisted_40 = { class: "overflow-auto" }
const _hoisted_41 = { class: "table table-striped border-light align-middle" }
const _hoisted_42 = { class: "text-nowrap" }
const _hoisted_43 = {
  class: "text-break",
  style: {"max-width":"24rem","white-space":"pre-wrap"}
}
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = { class: "form-label text-capitalize-first" }
const _hoisted_46 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TelegramBroadcastAudienceSpecForm = _resolveComponent("TelegramBroadcastAudienceSpecForm")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.centerEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.helper.trans('notification_center.access_denied')), 1))
            : (_ctx.broadcastEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("ul", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab,
                          class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.activeTab = tab), ["prevent"]),
                            class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTab === tab}])
                          }, _toDisplayString(_ctx.helper.trans(`notification_center.tab.${tab}`)), 11, _hoisted_6)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.activeTab === _ctx.Tabs.broadcast)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.helper.trans('notification_center.message_text')), 1),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.broadcastText) = $event)),
                                    class: "form-control",
                                    rows: "6"
                                  }, null, 512), [
                                    [_vModelText, _ctx.broadcastText]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("input", {
                                      id: "audienceModeSaved",
                                      class: "form-check-input",
                                      type: "radio",
                                      value: "saved",
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.audienceMode) = $event))
                                    }, null, 512), [
                                      [_vModelRadio, _ctx.audienceMode]
                                    ]),
                                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans('notification_center.audience_mode.saved')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _withDirectives(_createElementVNode("input", {
                                      id: "audienceModeAdhoc",
                                      class: "form-check-input",
                                      type: "radio",
                                      value: "adhoc",
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.audienceMode) = $event))
                                    }, null, 512), [
                                      [_vModelRadio, _ctx.audienceMode]
                                    ]),
                                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans('notification_center.audience_mode.adhoc')), 1)
                                  ])
                                ]),
                                (_ctx.audienceMode === 'saved')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.helper.trans('notification_center.audience_name')), 1),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAudienceId) = $event)),
                                        class: "form-select form-select-sm"
                                      }, [
                                        _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.select')), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audiences, (item) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: item.id,
                                            value: item.id
                                          }, _toDisplayString(item.name), 9, _hoisted_22))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _ctx.selectedAudienceId]
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createVNode(_component_TelegramBroadcastAudienceSpecForm, {
                                        modelValue: _ctx.adhocSpec,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adhocSpec) = $event))
                                      }, null, 8, ["modelValue"])
                                    ])),
                                _createElementVNode("div", _hoisted_24, [
                                  (_ctx.previewLoading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
                                      ])))
                                    : (_ctx.previewChatCount !== null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.helper.trans('notification_center.preview_result', {count: _ctx.previewChatCount})), 1))
                                      : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary btn-sm text-capitalize-first ms-auto",
                                    disabled: !_ctx.canSend,
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendConfirmModal = true))
                                  }, _toDisplayString(_ctx.helper.trans('notification_center.send')), 9, _hoisted_27)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTab === _ctx.Tabs.audiences)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-outline-primary btn-sm text-capitalize",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openAudienceModal()))
                              }, _toDisplayString(_ctx.helper.trans('button.create')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("table", _hoisted_33, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('notification_center.author')), 1),
                                    _cache[21] || (_cache[21] = _createElementVNode("th", { class: "text-end" }, null, -1))
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audiences, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: item.id
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.createdByName), 1),
                                      _createElementVNode("td", _hoisted_34, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-sm btn-outline-dark me-2",
                                          onClick: ($event: any) => (_ctx.openAudienceModal(item))
                                        }, _cache[22] || (_cache[22] = [
                                          _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
                                        ]), 8, _hoisted_35),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-sm btn-outline-danger",
                                          onClick: ($event: any) => (_ctx.confirmDeleteAudience(item))
                                        }, _cache[23] || (_cache[23] = [
                                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                        ]), 8, _hoisted_36)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTab === _ctx.Tabs.journal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("table", _hoisted_41, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('notification_center.author')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('notification_center.audience_name')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('notification_center.chat_count')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('notification_center.message_text')), 1)
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journal.items, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: item.id
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.createdByName), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.audienceName ?? _ctx.helper.trans('notification_center.one_off_audience')), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.chatCount), 1),
                                      _createElementVNode("td", _hoisted_43, _toDisplayString(item.text), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              (_ctx.journal.totalCount > _ctx.journal.items.length)
                                ? (_openBlock(), _createBlock(_component_b_pagination, {
                                    key: 0,
                                    modelValue: _ctx.journalPage,
                                    "onUpdate:modelValue": [
                                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.journalPage) = $event)),
                                      _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadJournal()))
                                    ],
                                    "total-rows": _ctx.journal.totalCount,
                                    "per-page": _ctx.JOURNAL_PAGE_SIZE,
                                    limit: 20,
                                    "prev-text": "Back",
                                    "next-text": "Next",
                                    align: "start",
                                    "first-number": "",
                                    "hide-goto-end-buttons": "",
                                    "hide-ellipsis": ""
                                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_b_modal, {
        title: _ctx.audienceModalTitle,
        modelValue: _ctx.audienceModalOpen,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.audienceModalOpen = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm text-capitalize-first",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.audienceModalOpen = false))
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "audienceSaveLoader",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary btn-sm text-capitalize-first",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveAudience && _ctx.saveAudience(...args)))
              }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
            ]),
            _: 1
          }, 512)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.helper.trans('notification_center.audience_name')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.audienceFormName) = $event)),
              type: "text",
              class: "form-control form-control-sm"
            }, null, 512), [
              [_vModelText, _ctx.audienceFormName]
            ])
          ]),
          (_ctx.audienceModalOpen)
            ? (_openBlock(), _createBlock(_component_TelegramBroadcastAudienceSpecForm, {
                key: _ctx.audienceFormKey,
                modelValue: _ctx.audienceFormSpec,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.audienceFormSpec) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.delete_confirm'),
        modelValue: _ctx.deleteAudienceModalOpen,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.deleteAudienceModalOpen = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm text-capitalize-first",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteAudienceModalOpen = false))
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "deleteAudienceLoader",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-danger btn-sm text-capitalize-first",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.deleteAudience && _ctx.deleteAudience(...args)))
              }, _toDisplayString(_ctx.helper.trans('button.delete')), 1)
            ]),
            _: 1
          }, 512)
        ]),
        default: _withCtx(() => [
          (_ctx.audienceToDelete)
            ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.audienceToDelete.name), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('button.confirm'),
        modelValue: _ctx.sendConfirmModal,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendConfirmModal = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm text-capitalize-first",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sendConfirmModal = false))
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "sendLoader",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary btn-sm text-capitalize-first",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.sendBroadcast && _ctx.sendBroadcast(...args)))
              }, _toDisplayString(_ctx.helper.trans('button.confirm')), 1)
            ]),
            _: 1
          }, 512)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.helper.trans('notification_center.send_confirm', {count: _ctx.previewChatCount ?? 0})), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _: 1
  }, 512))
}